<template>
    <div class="item">
        <i class="left floated large file middle aligned icon"></i>
        <i
            class="left floated large trash icon link"
            @click="remove"
        ></i>
        <div class="content">
            <span
                class="float-left text-red-500 cursor-pointer"
                @click="remove"
            >
                <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    class="w-5 h-5"
                >
                    <path
                        fill-rule="evenodd"
                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                        clip-rule="evenodd"
                    ></path>
                </svg>
            </span>
            <span
                @click.stop="download"
                class="cursor-pointer hover:underline"
            >{{ file.filename }}</span>
        </div>
    </div>
</template>
<script type="text/javascript">
export default {
    props: {
        file: {
            required: false
        },
        index: {
            required: false
        }
    },
    methods: {
        download() {
            this.$store.dispatch("file/DOWNLOAD", this.file);
        },
        remove() {
            this.$emit("remove", { index: this.index });
        }
    }
};
</script>
